import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";

const links = [
    { to: "/", label: "Accueil" },
    { to: "/galerie", label: "Galerie" },
    { to: "/a-propos", label: "L'artiste" },
    { to: "/expositions", label: "Expositions" },
    { to: "/livre-d-or", label: "Livre d'or" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => { setOpen(false); }, [pathname]);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled || open ? "backdrop-blur-xl bg-[var(--bg)] border-b border-[var(--border)]" : "bg-transparent"
                }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
                    <span className="w-8 h-8 border border-gilt flex items-center justify-center text-gilt italic-serif text-lg group-hover:bg-gilt group-hover:text-[var(--bg)] transition-colors duration-500">
                        M
                    </span>
                    <div className="leading-tight">
                        <div className="serif text-xl tracking-wide">Patrick Mathurin</div>
                        <div className="overline text-[9px] -mt-0.5">Peintre · Autodidacte</div>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-10">
                    {links.map((l) => {
                        const active = pathname === l.to;
                        return (
                            <Link
                                key={l.to}
                                to={l.to}
                                data-testid={`nav-${l.label.toLowerCase().replace(/[\s']/g, "-")}`}
                                className={`relative text-[12px] uppercase tracking-[0.22em] font-medium transition-colors ${active ? "text-gilt" : "text-bone-50/80 hover:text-gilt"
                                    }`}
                            >
                                {l.label}
                                {active && <span className="absolute -bottom-2 left-0 right-0 h-px bg-gilt" />}
                            </Link>
                        );
                    })}
                    <ThemeToggle className="ml-2" />
                </nav>

                <div className="lg:hidden flex items-center gap-3">
                    <ThemeToggle />
                    <button
                        data-testid="nav-toggle"
                        onClick={() => setOpen((o) => !o)}
                        className="p-2 text-bone-50"
                        aria-label="Menu"
                    >
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-[var(--border)] bg-[var(--bg)] shadow-2xl">
                    <nav className="px-6 py-6 flex flex-col gap-4">
                        {links.map((l) => (
                            <Link
                                key={l.to}
                                to={l.to}
                                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/[\s']/g, "-")}`}
                                className="text-sm uppercase tracking-[0.22em] py-2 border-b border-[var(--border)]"
                            >
                                {l.label}
                            </Link>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
}
